// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container_vbNWP {
  padding-top: var( --size-padMedium, 8px )
}`, "",{"version":3,"sources":["webpack://./src/plugins/dataViewers/lineStageGanttChart/CycleAndWorkforceTracking.css"],"names":[],"mappings":"AAAA;EACE;AACF","sourcesContent":[".container {\n  padding-top: var( --size-padMedium, 8px )\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `container_vbNWP`
};
export default ___CSS_LOADER_EXPORT___;
